import { useUserContext } from "../contexts/UserContext";

const useOwnerContext = () => {
  const { getAllOwners, getOwnerForRequests, hasOwner } = useUserContext();

  const getOwners = () => getAllOwners();
  const getPrimaryOwner = () => getOwnerForRequests();
  const canAccessOwner = (owner: string) => hasOwner(owner);

  return {
    getOwners,
    getPrimaryOwner,
    canAccessOwner,
  };
};

export default useOwnerContext;
